export const createHiddenIFrame = (url: string) => {
  const iframe = document.createElement('iframe');
  iframe.src = url;
  iframe.width = '1px';
  iframe.height = '1px';
  iframe.style.zIndex = '-1';
  iframe.style.position = 'fixed';
  iframe.style.left = '0';
  iframe.style.top = '0';
  document.body.appendChild(iframe);
  return iframe;
};

export const checkIsIFrameLoaded = (iFrame: HTMLIFrameElement) => new Promise((resolve) => {
  iFrame.addEventListener('load', () => {
    setTimeout(() => {
      resolve(true);
    }, 1500);
  });
});
